import React from 'react'

interface Props {
    label: React.ReactNode
    isLoading?: boolean
    disabled?: boolean
    varient?: 'primary' | 'secondary' | 'success' | 'danger'
    submitHandler?: (data: any) => any
}

const SubmitButton = ({ label, isLoading, disabled, varient = 'primary', submitHandler }: Props) => {
    return (
        <button type='submit' className={`btn btn-${varient}`} disabled={disabled || isLoading} onClick={submitHandler} >
            <span className='me-2'>{label}</span>
            {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}
        </button>
    )
}

export default SubmitButton